<script>
  import { stopPropagation } from "./genericHandlers";
  import { userInfo } from "./store";

  export let attribution;
  export let isUserSound;
</script>

{#if isUserSound || attribution}
  <div class="sound-attribution">
    {#if isUserSound}
      Uploaded By {$userInfo.username}
    {:else if attribution}
      By <a
        href={attribution.Author.Url}
        on:pointerdown={stopPropagation}
        on:mousedown={stopPropagation}
        target="_blank">{attribution.Author.Name}</a
      >.
      <a
        href={attribution.License.Url}
        on:pointerdown={stopPropagation}
        on:mousedown={stopPropagation}
        target="_blank">{attribution.License.Name}</a
      >
    {/if}
  </div>
{/if}
